import { createBrowserRouter, Navigate } from "react-router-dom";

import { solicitudesRoutes } from "@features/Solicitudes";
import { solicitudRoutes } from "@features/Solicitud/routes/solicitud";
import { loginRoutes } from "@features/Autenticacion/routes/login";
import { adminRoutes } from "@features/Administracion/routes/admin";

const router = createBrowserRouter([
    solicitudesRoutes,
    solicitudRoutes,
    adminRoutes,
    loginRoutes,
    {
        path: "*",
        element: <Navigate to="/" replace />,
    },
]);

export default router;
